import React from "react";
import HomeTutors from "./updateHomeOne/HomeTutors";
import HomeOneCounter from "./updateHomeOne/HomeOneCounter";

import HomeHeroGreen from "./GreenHome/HomeHeroGreen";
import HomeTutorContentGreen from "./GreenHome/HomeTutorContentGreen";
import HomeStudentContentGreen from "./GreenHome/HomeStudentContentGreen";
import HomeMobile from "./GreenHome/HomeMobile";
import "./homeMain11.css";

const Home = () => {
  return (
    <div className="">
      <div className="desktop-components">
        <HomeHeroGreen></HomeHeroGreen>
        <HomeOneCounter></HomeOneCounter>
        <HomeTutorContentGreen></HomeTutorContentGreen>
        <HomeTutors></HomeTutors>
        <HomeStudentContentGreen></HomeStudentContentGreen>
      </div>
      <div className="mobile-component">
        <HomeMobile></HomeMobile>
      </div>
    </div>
  );
};

export default Home;
